import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";

import {
  addProductStyleAsync,
  addProductItemTypeAsync,
  deleteProductItemTypeAsync,
  editProductStyleAsync,
  editProductItemTypeAsync,
  getProductStyleAsync,
  getProductItemTypeAsync,
} from "../../../../store/services/productInfoServices";
const ItemType = () => {
  const dispatch = useDispatch();
  const {
    getProductItemTypeStatus,
    getProductItemTypeError,
    getProductItemTypeData,
    addProductItemTypeStatus,
    addProductItemTypeData,
    addProductItemTypeError,

    editProductItemTypeStatus,
    editProductItemTypeError,
    editProductItemTypeData,

    deleteProductItemTypeData,
    deleteProductItemTypeStatus,
    deleteProductItemTypeError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductItemTypeAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductItemTypeData?.length
    ? getProductItemTypeData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedItemType, setSelectedItemType] = useState();
  const [addItemTypeMode, setAddItemTypeMode] = useState(false);
  const [addItemTypeData, setAddItemTypeData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedItemType", selectedItemType);
  // console.log("editData", editData);

  useEffect(() => {
    if (addProductItemTypeStatus === asyncStatus.SUCCEEDED) {
      setAddItemTypeMode(false);
      setSaveDisabled(true);
      setAddItemTypeData();
    }
  }, [, addProductItemTypeStatus]);

  const [open, setOpen] = useState(false);
  
  const agree = () => {
    dispatch(deleteProductItemTypeAsync(selectedItemType?.item_type_id));
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (deleteProductItemTypeStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedItemType();
    }
  }, [, deleteProductItemTypeStatus]);
  useEffect(() => {
    if (editProductItemTypeStatus === asyncStatus.SUCCEEDED) {
      setSelectedItemType();
      setEditMode(false);
    }
  }, [, editProductItemTypeStatus]);
console.log("getProductItemTypeData",getProductItemTypeData,editProductItemTypeData);
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this ItemType?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="ItemType"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Item Type Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddItemTypeMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addItemTypeMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addItemTypeMode || !selectedItemType}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddItemTypeMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addItemTypeMode || !selectedItemType}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductItemTypeStatus === asyncStatus.LOADING ||
                  editProductItemTypeStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addItemTypeData) {
                    dispatch(addProductItemTypeAsync(addItemTypeData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedItemType, ...editData };
                    delete a.id;
                    dispatch(editProductItemTypeAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "item_type_id", headerName: "ID", flex: true },
                  {
                    field: "item_type_name",
                    headerName: "ItemType Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedItemType(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductItemTypeStatus === asyncStatus.IDLE ||
                  getProductItemTypeStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addItemTypeMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "Item Type:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddItemTypeData({
                            ...addItemTypeData,
                            item_type_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Item Type Code:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddItemTypeData({
                            ...addItemTypeData,
                            item_type_code: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddItemTypeData({
                            ...addItemTypeData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedItemType ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedItemType?.item_type_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "ItemType:",
                    comp: (
                      <InputComp
                        key={selectedItemType?.item_type_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            item_type_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedItemType?.item_type_name}
                      />
                    ),
                  },
                  {
                    label: "Item Type Code:",
                    comp: (
                      <InputComp
                        key={selectedItemType?.item_type_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            item_type_code: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedItemType?.item_type_code}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedItemType?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedItemType?.is_active ? true : false
                        }
                        checked={selectedItemType?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any item type</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductItemTypeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductItemTypeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductItemTypeError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductItemTypeError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  // {
                  //   name: "Companies",
                  //   content: (
                  //     <Stack height={400} width={"100%"}>
                  //       <TableComp
                  //         columns={[
                  //           {
                  //             field: "companyId",
                  //             headerName: "Company ID",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "companyName",
                  //             headerName: "Company Name",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "action",
                  //             headerName: "Action",
                  //             flex: true,
                  //           },
                  //         ]}
                  //         //   onRowClick={(e) => {
                  //         //     setSelectedItemType(e?.row);
                  //         //   }}
                  //         rows={[]}
                  //         //   loading={
                  //         //     getProductStyleStatus === asyncStatus.IDLE ||
                  //         //     getProductStyleStatus === asyncStatus.LOADING
                  //         //   }
                  //       />
                  //     </Stack>
                  //   ),
                  // },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedItemType(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default ItemType;
